export default __webpack_public_path__ + "static/media/Nosotros_imagen1_320.5e52c1b2.jpg";